module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljirooraeorae-1.ver2_0_2.gif?840a8efd";